import { useEffect, useState } from "react";
import { useGetSubscriptionEventsQuery } from "../../services/resourceGroups/subscriptionApi";
import { addDays, roundToNearestMinutes, startOfDay } from "date-fns";

function usePagedEventQueries(subscriptionId: string, pageSize: number = 10) {
  const start = startOfDay(addDays(new Date(), -30));
  const end = roundToNearestMinutes(new Date(), { nearestTo: 5 });
  const [page, setPage] = useState(0);
  const [pagedData, setPagedData] = useState<any[]>([]);
  const { data, isSuccess, isLoading, error, isFetching } = useGetSubscriptionEventsQuery({
    page: page,
    pageSize: pageSize,
    start: start.toISOString(),
    end: end.toISOString(),
    id: subscriptionId,
  });

  useEffect(() => {
    if (data?.data) {
      setPagedData((prev) => [...prev, ...data.data]);
    }
  }, [data]);

  useEffect(() => {
    if (isLoading) {
      setPagedData([]);
    }
  }, [isLoading]);
  useEffect(() => {
    if (page === 0) {
      setPagedData([]);
    }
  }, [page]);

  return {
    data: pagedData,
    isLoading: isLoading,
    isSuccess: isSuccess,
    error: error,
    page: page,
    setPage: setPage,
    total: data?.total ?? 0,
    hasMore: (page + 1) * pageSize < (data?.total ?? 0),
    isFetching: isFetching,
  };
}

export default usePagedEventQueries;
